module.exports = __webpack_public_path__ + "static/img/1.1ef66537.jpg";